<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-textarea
        v-model.trim="innerValue"
        :label="label"
        :error-messages="errors"
        :readonly="readonly"
        :prepend-icon="prependIcon"
        :rows="rows"
        outlined>
      <template
          v-if="required"
          v-slot:prepend-inner>
        <v-icon
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-textarea>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      rows: {
        type: [String, Number],
        default: 3
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
      }
    }
  }
</script>
